import { apolloClient } from '@/store/graphql.config'
import { fetchCategoriesQuery } from '@/store/modules/catalog/queries/fetchCategories.query'
import { IProduct, IProductInfo } from '@/store/modules/catalog/interfaces/products/IProduct'
import { ICategory } from '@/store/modules/catalog/interfaces/categories/ICategory'
import { fetchProductsQuery } from '@/store/modules/catalog/queries/fetchProducts.query'
import { fetchProductsAggregationsQuery } from '@/store/modules/catalog/queries/fetchProductsAggregations.query'
import { fetchProductQuery } from '@/store/modules/catalog/queries/fetchProduct.query'
import { fetchFreeBeersInfo } from '@/store/modules/catalog/queries/fetchFreeBeersInfo.query'
import { fetchWishlistQuery } from '@/store/modules/catalog/queries/fetchWishlist.query'
import { fetchFreeBeerIdsQuery } from '@/store/modules/catalog/queries/fetchFreeBeerIds.query'
import { fetchFreeBeerProductQuery } from '@/store/modules/catalog/queries/fetchFreeBeerProduct.query'

import { fetchRecommendedListQuery } from '@/store/modules/catalog/queries/fetchRecommendedList.query'
import { fetchProductsToWishlistMutation } from '@/store/modules/catalog/mutations/fetchProductsToWishlist.mutation'
import {
  IFetchProductsResponse,
  IFetchProductsPageInfo,
  IAggregations,
  ICategoryFilter
} from '@/store/modules/catalog/interfaces/products/api/fetchProducts/IFetchProductsResponse.'
import { IFetchProductsRequest } from '@/store/modules/catalog/interfaces/products/api/fetchProducts/IFetchProductsRequest'
import { IWishList } from '@/store/modules/catalog/interfaces/wishList/IWishList'
import { IRecommendItems } from '@/store/modules/catalog/interfaces/recommended/IRecommendItems'
import { IFetchWishListResponse } from '@/store/modules/catalog/interfaces/wishList/api/fetchWishList/IFetchWishListResponse'
import { IFetchRecommendItemsResponse } from '@/store/modules/catalog/interfaces/recommended/api/fetchRecommended/IFetchRecommItemsResponse'
import { IFetchRecommItemsRequest } from '@/store/modules/catalog/interfaces/recommended/api/fetchRecommended/IFetchRecommItemsRequest'
import {
  IFetchFreeBeerIdInput,
  IFetchFreeBeerIdResponse,
  IFetchFreeBeerProductResponse,
  IAddFreeBeerCartResponse,
  IAddFreeBeerCartRequest,
  IAddFreeBeerCompleteLayerRequest,
  IRemoveFreeBeerCartRequest,
  IAddFreeBeerCompleteLayerResponse,
  IFetchFreeBeerInfoResponse,
  IFetchFreeBeerInfoRequest,
  IRemoveMultipleFreeBeerCartRequest
}
  from '@/store/modules/catalog/interfaces/freebeer/IFetchFreeBeer'

import { IFetchAddToWishListRequest } from '@/store/modules/catalog/interfaces/wishList/api/fetchAddToWishList/IFetchAddToWishListRequest'
import {
  IFetchAddToWishListResponse,
  ItemType
} from '@/store/modules/catalog/interfaces/wishList/api/fetchAddToWishList/IFetchAddToWishListResponse'
import { CatalogMutationType } from '@/store/modules/catalog/interfaces/mutation-type'
import { ActionTree, MutationTree } from 'vuex'
import { CatalogActionType } from '@/store/modules/catalog/interfaces/action-type'
import { IFetchCategoriesResponse } from '@/store/modules/catalog/interfaces/categories/fetchCategories/IFetchCategoriesResponse'
import { ICatalogState } from '@/store/modules/catalog/interfaces/ICatalogState'
import { ICatalogMutations } from '@/store/modules/catalog/interfaces/ICatalogMutations'
import { AlignmentType } from '@/store/modules/catalog/interfaces/common/aligmentType'
import { IRootState } from '@/store'
import { IError } from '@/store/modules/catalog/interfaces/common/IError'
import { IQueries } from '@/store/modules/catalog/interfaces/common/IQueries'
import { IFetchCategoriesRequest } from '@/store/modules/catalog/interfaces/categories/fetchCategories/IFetchCategoriesRequest'
import { IFilter } from '@/store/modules/catalog/interfaces/common/IFilter'
import { IFetchRemoveFromWishListRequest } from '@/store/modules/catalog/interfaces/wishList/api/fetchRemoveFromWithList/IFetchRemoveFromWithListRequest'
import { IFetchRemoveFromWishListResponse } from '@/store/modules/catalog/interfaces/wishList/api/fetchRemoveFromWithList/IFetchRemoveFromWithListResponse'
import { fetchProductFromWishlistMutation } from '@/store/modules/catalog/mutations/fetchProductFromWishlist.mutation'
import { ICatalogActions } from '@/store/modules/catalog/interfaces/ICatalogActions'
import { updateObjectInArray } from '@/utils/functions/updateObjectInArray'
import { fetchAvailablePackagingQuery } from '@/store/modules/catalog/queries/fetchAvailablePackagingQuery'
import { IFetchAvailablePackagingRequest } from '@/store/modules/catalog/interfaces/products/api/fetchAvailablePackaging/IFetchAvailablePackagingRequest'
import {
  IAvaliablePackagingItem,
  IFetchAvailablePackagingResponse
} from '@/store/modules/catalog/interfaces/products/api/fetchAvailablePackaging/IFetchAvailablePackagingResponse'
import { AxiosResponse } from 'axios'
import { generalServiceV1API } from '@/store/api-instance'
import { IFetchShipToRequest, IFetchShipToIdRequest } from './interfaces/shipto/IShipToRequest'
import { IFetchShipToResponse, IFetchShipToIdResponse, IShipToBySapId, IShipToById, IShipToMethod, IFetchShipToMethodResponse, IFetchPaymentMethodResponse } from './interfaces/shipto/IShipToResponse'
import { constants } from '@/constants'
import { fetchProductWishlistQuery } from './queries/fetchProductWishlistQuery'
import { fetchAddToFullOrderMutation } from '@/store/modules/catalog/mutations/fetchAddToFullOrder.mutation'
import { IFullOrderRequest, IFullOrderResponse } from '@/store/modules/catalog/interfaces/fullorder/IFullOrder'

import { fetchAddFreeBeerToCartMutation } from '@/store/modules/catalog/mutations/fetchAddFreeBeerToCart.mutation'
import { fetchAddCompleteLayerMutation } from '@/store/modules/catalog/mutations/fetchAddCompleteLayer.mutation'

import { fetchRemoveFreeBeerToCartMutation } from '@/store/modules/catalog/mutations/fetchRemoveFreeBeerToCart.mutation'

import utils from '@/utils/auth'
import { fetchRemoveMultipleFreeBeer } from './mutations/fetchRemoveMultipleFreeBeer.mutation'
import { fetchProductsSearchQuery } from './queries/fetchProductsSearchQuery'

const defaultProductsState = {
  products: [],
  productsInfo: {
    page_size: 10,
    total_pages: 2,
    current_page: 1
  }
}

const state = (): ICatalogState => ({
  ...defaultProductsState,
  categories: [],
  categoryFilter: [],
  filters: [],
  favoritesFilters: [],
  favorites: [],
  favoritesInfo: {} as IProductInfo,
  openedProduct: null,
  wishlist: null,
  recommendItems: null,
  recommendedList: [],
  loading: false,
  favoritesLoading: false,
  alignment: 'grid',
  queries: {
    sort: { default_sort: 'ASC' },
    search: '',
    category_uid: [],
    category_id: [],
    brand: [],
    sub_brand: [],
    pack_format: [],
    type: [],
    material_type: [],
    price: [],
    volume: []
  },
  errors: null,
  shipTos: [],
  shipToAddress: [],
  productFreeBeersInfo: [],
  shipToMethod: [],
  paymentMethod: [],
  productWishlist: [],
  productWishlistInfo: {} as IProductInfo,
  fullOrderDetails: {} as IFullOrderResponse,
  sortCatalogue: {},
  sortQuickOrder: {},
  sortFavorite: {},
  lowStockProductList: [],
  showLowStock: true,
  productFreeBeer: [],
  productAddBeerProduct: {},
  freeBeersRunning: false,
  shipToId: '',
  totalCount: 0,
  specialOffersTotalCount: 0,
  quickOrdersTotalCount: 0,
  specialOffer: [],
  quickOrders: [],
  products_search: [],
  specialOfferInfo: {
    page_size: 10,
    total_pages: 1,
    current_page: 1
  },
  quickOrdersInfo: {
    page_size: 10,
    total_pages: 1,
    current_page: 1
  }
})

const mutations: MutationTree<ICatalogState> & ICatalogMutations = {
  [CatalogMutationType.SET_LOADING] (state, payload: boolean) {
    state.loading = payload
  },
  [CatalogMutationType.SET_PRODUCTS] (state, payload: IProduct[]) {
    state.products = payload
  },
  [CatalogMutationType.SET_PRODUCTS_SEARCH] (state, payload: IProduct[]) {
    state.products_search = payload
  },
  [CatalogMutationType.SET_SPECIAL_OFFER] (state, payload: IProduct[]) {
    state.specialOffer = payload
  },
  [CatalogMutationType.SET_QUICK_ORDERS] (state, payload: IProduct[]) {
    state.quickOrders = payload
  },
  [CatalogMutationType.SET_CATEGORIES_FILTER] (state, payload: ICategoryFilter[]) {
    state.categoryFilter = payload
  },
  [CatalogMutationType.SET_PRODUCTS_INFO] (state, payload: IFetchProductsPageInfo) {
    state.productsInfo = payload
  },
  [CatalogMutationType.SET_SPECIAL_OFFER_INFO] (state, payload: IFetchProductsPageInfo) {
    state.specialOfferInfo = payload
  },
  [CatalogMutationType.SET_QUICK_ORDERS_INFO] (state, payload: IFetchProductsPageInfo) {
    state.quickOrdersInfo = payload
  },
  [CatalogMutationType.RESET_PRODUCTS_PAGE] (state) {
    state.products = [...defaultProductsState.products]
    state.productsInfo = { ...defaultProductsState.productsInfo }
  },
  [CatalogMutationType.SET_FILTERS] (state, payload: IAggregations[]) {
    state.filters = payload
  },
  [CatalogMutationType.SET_FAVORITES_FILTERS] (state, payload: IAggregations[]) {
    state.favoritesFilters = payload
  },
  [CatalogMutationType.SET_FAVORITES] (state, payload: IProduct[]) {
    state.favorites = payload
  },
  [CatalogMutationType.SET_FAVORITES_INFO] (state, payload: IFetchProductsPageInfo) {
    state.favoritesInfo = payload
  },
  [CatalogMutationType.SET_PRODUCT] (state, payload: IProduct) {
    state.openedProduct = payload
  },
  [CatalogMutationType.SET_PACKAGING] (state, payload: IAvaliablePackagingItem[]) {
    if (!state.openedProduct) return
    state.openedProduct.avaliablePackaging = payload
  },
  [CatalogMutationType.SET_WISHLIST] (state, payload: IWishList) {
    state.wishlist = payload
  },
  [CatalogMutationType.SET_RECOMMENDED_ITEMS] (state, payload: IRecommendItems) {
    state.recommendItems = payload
  },
  [CatalogMutationType.SET_RECOMMENDED] (state, payload: IProduct[]) {
    state.recommendedList = payload
  },

  [CatalogMutationType.SET_LOW_STOCK_PRODUCT] (state, payload: IProduct[]) {
    state.lowStockProductList = payload
  },
  [CatalogMutationType.SET_SHOW_LOW_STOCK_PRODUCT] (state, payload: boolean) {
    state.showLowStock = payload
  },

  [CatalogMutationType.SET_CATEGORIES] (state, payload: ICategory[]) {
    state.categories = payload
  },
  [CatalogMutationType.SET_ALIGNMENT] (state, payload: AlignmentType) {
    state.alignment = payload
  },
  [CatalogMutationType.SET_QUERIES] (state, payload: IQueries) {
    state.queries = payload
  },

  [CatalogMutationType.SET_ERROR] (state, payload: IError[]) {
    state.errors = payload
  },
  [CatalogMutationType.SET_FAVORITES_LOADING] (state, payload: boolean) {
    state.favoritesLoading = payload
  },
  [CatalogMutationType.SET_SHIP_TO] (state, payload: IShipToBySapId[]) {
    state.shipTos = payload
  },
  [CatalogMutationType.SET_SHIP_TO_ID] (state, payload: string) {
    state.shipToId = payload
  },
  [CatalogMutationType.SET_SHIP_TO_ADDRESS] (state, payload: IShipToById[]) {
    state.shipToAddress = payload
  },

  [CatalogMutationType.SET_SHIP_TO_METHOD] (state, payload: IShipToMethod[]) {
    state.shipToMethod = payload
  },

  [CatalogMutationType.SET_PAYMENT_METHOD] (state, payload: any) {
    state.paymentMethod = payload
  },
  [CatalogMutationType.SET_PRODUCT_WISHLIST] (state, payload: IProduct[]) {
    state.productWishlist = payload
  },
  [CatalogMutationType.SET_PRODUCT_WISHLIST_INFO] (state, payload: IProductInfo) {
    state.productWishlistInfo = payload
  },
  [CatalogMutationType.SET_ADD_TO_FULL_ORDER] (state, payload: IFullOrderResponse) {
    state.fullOrderDetails = payload
  },
  [CatalogMutationType.SET_CATALOGUE_SORT] (state, payload: any) {
    state.sortCatalogue = payload
  },
  [CatalogMutationType.SET_QUICK_ORDER_SORT] (state, payload: any) {
    state.sortQuickOrder = payload
  },
  [CatalogMutationType.SET_FAVOURITE_SORT] (state, payload: any) {
    state.sortFavorite = payload
  },
  [CatalogMutationType.SET_FREE_BEER_PRODUCT] (state, payload: any) {
    state.productFreeBeer = payload
  },
  [CatalogMutationType.SET_ADD_FREE_BEER_PRODUCT] (state, payload: any) {
    state.productAddBeerProduct = payload
  },
  [CatalogMutationType.SET_FREEBEERS_INFO] (state, payload: any) {
    state.productFreeBeersInfo = payload
  },
  [CatalogMutationType.SET_FREEBEERS_RUNNING] (state, payload: boolean) {
    state.freeBeersRunning = payload
  },
  [CatalogMutationType.SET_TOTAL_COUNT] (state, payload: number) {
    state.totalCount = payload
  },
  [CatalogMutationType.SET_SPECIAL_OFFER_TOTAL_COUNT] (state, payload: number) {
    state.specialOffersTotalCount = payload
  },
  [CatalogMutationType.SET_QUICK_ORDERS_TOTAL_COUNT] (state, payload: number) {
    state.quickOrdersTotalCount = payload
  }

}
export const actions: ActionTree<ICatalogState, IRootState> & ICatalogActions = {
  async [CatalogActionType.FETCH_PRODUCTS] ({ commit, state }, dto: IFetchProductsRequest & IFilter) {
    try {
      const variables = Object.entries({
        is_peroni: constants.application.theme === 'peroni',
        currentPage: 1,
        pageSize: dto.pageSize,
        ...state.queries,
        ...dto
      }).reduce((acc: { [key: string]: any }, [key, value]) => {
        if (dto.search && String(dto.search).trim() !== '' && key === 'sort') {
          return acc
        }
        if (Array.isArray(value)) {
          if (value.length > 0) acc[key] = value
        } else if (value != null && value !== '') acc[key] = value
        return acc
      }, {})

      if (!variables?.sort && variables?.category_id && variables?.category_id[0] === 4) {
        variables.sort = { default_sort: 'ASC' }
      }
      if (!variables.bypassLoading) {
        commit(CatalogMutationType.SET_LOADING, true)
      }
      const { data } = await apolloClient.query<IFetchProductsResponse, IFetchProductsRequest & IFilter>({
        query: fetchProductsQuery,
        variables,
        fetchPolicy: variables.fetchPolicy || 'cache-first'
      })
      commit(CatalogMutationType.SET_TOTAL_COUNT, data?.products?.total_count || 0)
      if (data) {
        commit(CatalogMutationType.SET_PRODUCTS, data?.products?.items || [])
        commit(CatalogMutationType.SET_PRODUCTS_INFO, {
          ...(data?.products?.page_info || {}),
          total_count: data?.products?.total_count || 0
        })
        commit(CatalogMutationType.SET_FILTERS, data?.products?.aggregations || [])
        commit(CatalogMutationType.SET_CATEGORIES_FILTER, Array.isArray(data?.products?.categoryFilter) ? data?.products?.categoryFilter : [])
        commit(CatalogMutationType.SET_LOADING, false)
      }
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_PRODUCTS, [])
      commit(CatalogMutationType.SET_FILTERS, [])
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      commit(CatalogMutationType.SET_LOADING, false)
      throw e
    }
  },
  async [CatalogActionType.FETCH_PRODUCTS_SEARCH] ({ commit, state }, dto: IFetchProductsRequest & IFilter) {
    try {
      const variables = Object.entries({
        is_peroni: constants.application.theme === 'peroni',
        currentPage: 1,
        ...dto
      }).reduce((acc: { [key: string]: any }, [key, value]) => {
        if (Array.isArray(value)) {
          if (value.length > 0) acc[key] = value
        } else if (value != null && value !== '') acc[key] = value
        return acc
      }, {})

      const { data } = await apolloClient.query<IFetchProductsResponse, IFetchProductsRequest & IFilter>({
        query: fetchProductsSearchQuery,
        variables
      })

      if (data) {
        const products = JSON.parse(JSON.stringify(data.products.items))
        commit(CatalogMutationType.SET_PRODUCTS_SEARCH, data?.products?.items || [])
        commit(CatalogMutationType.SET_LOADING, false)
      }
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      commit(CatalogMutationType.SET_LOADING, false)
      throw e
    }
  },
  async [CatalogActionType.FETCH_SPECIAL_OFFERS] ({ commit, state }, dto: IFetchProductsRequest & IFilter) {
    try {
      const variables = Object.entries({
        is_peroni: constants.application.theme === 'peroni',
        currentPage: 1,
        pageSize: dto.pageSize,
        ...state.queries,
        ...dto
      }).reduce((acc: { [key: string]: any }, [key, value]) => {
        if (dto.search !== '' && key === 'sort') {
          return acc
        }
        if (Array.isArray(value)) {
          if (value.length > 0) acc[key] = value
        } else if (value != null && value !== '') acc[key] = value
        return acc
      }, {})
      const { data } = await apolloClient.query<IFetchProductsResponse, IFetchProductsRequest & IFilter>({
        query: fetchProductsQuery,
        variables,
        fetchPolicy: variables.fetchPolicy || 'cache-first'
      })
      commit(CatalogMutationType.SET_SPECIAL_OFFER_TOTAL_COUNT, data?.products?.total_count || 0)
      if (data) {
        commit(CatalogMutationType.SET_SPECIAL_OFFER, data?.products?.items || [])
        commit(CatalogMutationType.SET_SPECIAL_OFFER_INFO, {
          ...(data?.products?.page_info || {}),
          total_count: data?.products?.total_count || 0
        })
        commit(CatalogMutationType.SET_LOADING, false)
      }
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_SPECIAL_OFFER, [])
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      commit(CatalogMutationType.SET_LOADING, false)
      throw e
    }
  },
  async [CatalogActionType.FETCH_QUICK_ORDERS] ({ commit, state }, dto: IFetchProductsRequest & IFilter) {
    try {
      const variables = Object.entries({
        is_peroni: constants.application.theme === 'peroni',
        currentPage: 1,
        pageSize: dto.pageSize,
        ...state.queries,
        ...dto
      }).reduce((acc: { [key: string]: any }, [key, value]) => {
        if (dto.search !== '' && key === 'sort') {
          return acc
        }
        if (Array.isArray(value)) {
          if (value.length > 0) acc[key] = value
        } else if (value != null && value !== '') acc[key] = value
        return acc
      }, {})
      const { data } = await apolloClient.query<IFetchProductsResponse, IFetchProductsRequest & IFilter>({
        query: fetchProductsQuery,
        variables,
        fetchPolicy: variables.fetchPolicy || 'cache-first'
      })
      commit(CatalogMutationType.SET_QUICK_ORDERS_TOTAL_COUNT, data?.products?.total_count || 0)
      if (data) {
        commit(CatalogMutationType.SET_QUICK_ORDERS, data?.products?.items || [])
        commit(CatalogMutationType.SET_QUICK_ORDERS_INFO, {
          ...(data?.products?.page_info || {}),
          total_count: data?.products?.total_count || 0
        })
        commit(CatalogMutationType.SET_LOADING, false)
      }
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_QUICK_ORDERS, [])
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      commit(CatalogMutationType.SET_LOADING, false)
      throw e
    }
  },
  async [CatalogActionType.FETCH_LOW_STOCK_PRODUCTS] ({ commit, state }, dto: IFetchProductsRequest & IFilter) {
    try {
      const variables = Object.entries({
        is_peroni: false,
        currentPage: 1,
        ...state.queries,
        ...dto
      }).reduce((acc: { [key: string]: any }, [key, value]) => {
        if (Array.isArray(value)) {
          if (value.length > 0) acc[key] = value
        } else if (value != null && value !== '') acc[key] = value
        return acc
      }, {})

      commit(CatalogMutationType.SET_LOADING, true)
      const { data } = await apolloClient.query<IFetchProductsResponse, IFetchProductsRequest & IFilter>({
        query: fetchProductsQuery,
        variables
      })
      if (data) {
        commit(CatalogMutationType.SET_LOW_STOCK_PRODUCT, data?.products?.items || [])
        commit(CatalogMutationType.SET_SHOW_LOW_STOCK_PRODUCT, true)

        commit(CatalogMutationType.SET_LOADING, false)
      }
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      commit(CatalogMutationType.SET_LOADING, false)
      commit(CatalogMutationType.SET_SHOW_LOW_STOCK_PRODUCT, true)
      throw e
    }
  },
  async [CatalogActionType.FETCH_PRODUCTS_AGGREGATIONS] ({ commit }) {
    commit(CatalogMutationType.SET_LOADING, true)
    const { data } = await apolloClient.query<IFetchProductsResponse, IFetchProductsRequest & IFilter>({
      query: fetchProductsAggregationsQuery,
      variables: {
        // sku: state.queries.sku,
      }
    })
    commit(CatalogMutationType.SET_FILTERS, data?.products?.aggregations || [])
    commit(CatalogMutationType.SET_LOADING, false)
  },
  async [CatalogActionType.FETCH_PRODUCT] ({ commit, state }, dto: IFetchAvailablePackagingRequest) {
    try {
      const variables = localStorage.getItem('customertype') === 'Ontrade' ? { sku: dto?.sku, material_type: 'GLASSWARE' } : { sku: dto?.sku, material_type: dto?.material_type }
      commit(CatalogMutationType.SET_LOADING, true)
      const { data } = await apolloClient.query<IFetchProductsResponse, IFetchAvailablePackagingRequest>({
        query: fetchProductQuery,
        variables
      })
      if (data?.products?.items?.length > 1) {
        const product = data?.products?.items?.filter((product: IProduct) => product.sku === dto?.sku) as any
        commit(CatalogMutationType.SET_PRODUCT, { ...product[0], type: '' })
      } else {
        commit(CatalogMutationType.SET_PRODUCT, { ...data.products.items[0], type: '' })
      }

      const { data: packaging } = await apolloClient.query<
        IFetchAvailablePackagingResponse,
        IFetchAvailablePackagingRequest
      >({
        query: fetchAvailablePackagingQuery,
        variables: {
          sku: '',
          material_type: '',
          sap_sub_brand_code: state.openedProduct?.sub_brand
        }
      })
      commit(CatalogMutationType.SET_PACKAGING, packaging.getProductAvaliablePackaging)

      commit(CatalogMutationType.SET_LOADING, false)
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      commit(CatalogMutationType.SET_LOADING, false)
      throw e
    }
  },
  async [CatalogActionType.FETCH_WISHLIST] ({ commit }) {
    try {
      const getWishListData = async (
        currentPage = 1,
        oldData: IFetchWishListResponse = { customer: { wishlists: [] } }
      ): Promise<IFetchWishListResponse> => {
        const { data: wishListData } = await apolloClient.query<IFetchWishListResponse, object>({
          query: fetchWishlistQuery,
          variables: { currentPage }
        })

        oldData.customer.wishlists[0] = {
          ...(oldData.customer.wishlists?.[0] || {}),
          ...wishListData.customer.wishlists[0],
          items_v2: {
            ...(oldData.customer.wishlists?.[0]?.items_v2 || {}),
            ...wishListData.customer.wishlists[0].items_v2,
            items: [
              ...(oldData.customer.wishlists?.[0]?.items_v2?.items || []),
              ...wishListData.customer.wishlists[0].items_v2.items
            ]
          }
        }

        if (
          wishListData.customer.wishlists[0].items_v2.shipto_item_count >
          oldData.customer.wishlists[0].items_v2.items.length
        ) {
          return await getWishListData(currentPage + 1, oldData)
        }

        return oldData
      }

      const wishListData = await getWishListData()
      commit(CatalogMutationType.SET_WISHLIST, wishListData.customer.wishlists[0])
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      throw e
    }
  },
  async [CatalogActionType.FETCH_FAVORITES] ({ dispatch, commit, state }, dto: IFetchProductsRequest) {
    try {
      commit(CatalogMutationType.SET_LOADING, true)

      if (!dto?.currentPage) {
        await dispatch(CatalogActionType.FETCH_WISHLIST)
      }

      const skus: string[] =
        state.wishlist?.items_v2.items
          ?.map((item: ItemType) => item.product.sku)
          ?.filter((sku: string) => sku != null) || []

      const filterData = Object.entries({
        is_peroni: constants.application.theme === 'peroni',
        currentPage: 1,
        ...state.queries,
        ...dto
      }).reduce((acc: { [key: string]: any }, [key, value]) => {
        if (Array.isArray(value)) {
          if (value.length > 0) acc[key] = value
        } else if (value != null && value !== '') acc[key] = value
        return acc
      }, {})
      if (skus.length > 0) {
        const { data } = await apolloClient.query<IFetchProductsResponse, IFetchProductsRequest>({
          query: fetchProductsQuery,
          variables: {
            sku: skus,
            currentPage: 1,
            ...filterData
          }
        })
        commit(CatalogMutationType.SET_FAVORITES, data.products.items || [])
        commit(CatalogMutationType.SET_FAVORITES_FILTERS, data?.products?.aggregations || [])
        commit(CatalogMutationType.SET_FAVORITES_INFO, {
          ...(data?.products?.page_info || {}),
          total_count: data?.products?.total_count || 0
        })
      } else {
        commit(CatalogMutationType.SET_FAVORITES, [])
        commit(CatalogMutationType.SET_FAVORITES_FILTERS, [])
      }
      commit(CatalogMutationType.SET_LOADING, false)
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      commit(CatalogMutationType.SET_LOADING, false)
      throw e
    }
  },
  async [CatalogActionType.FETCH_RECOMMENDED_LIST] ({ commit }, dto: IFetchRecommItemsRequest) {
    try {
      const { data: recommendItems } = await apolloClient.query<IFetchRecommendItemsResponse, object>({
        query: fetchRecommendedListQuery,
        variables: { ...dto }
      })
      commit(CatalogMutationType.SET_RECOMMENDED_ITEMS, recommendItems.recommendItems)
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      throw e
    }
  },
  async [CatalogActionType.FETCH_RECOMMENDED_PRODUCTS] ({ dispatch, commit, state }, dto: IFetchRecommItemsRequest) {
    try {
      commit(CatalogMutationType.SET_LOADING, true)

      await dispatch(CatalogActionType.FETCH_RECOMMENDED_LIST, dto)
      const skus: string[] =
        state.recommendItems?.recItems
          ?.sort((a, b) => {
            const p1 = parseInt(a.Priority)
            const p2 = parseInt(b.Priority)
            return p1 !== p2 ? (p1 > p2 ? 1 : -1) : 0
          })
          ?.map((item) => item?.productId)
          ?.filter((sku: string) => sku != null) || []

      const { data } = await apolloClient.query<IFetchProductsResponse, IFetchProductsRequest>({
        query: fetchProductsQuery,
        variables: {
          sku: skus,
          currentPage: 1,
          product_type: 'simple',
          pageSize: state.recommendItems?.recItems?.length
        }
      })
      commit(CatalogMutationType.SET_RECOMMENDED, data.products.items)
      commit(CatalogMutationType.SET_LOADING, false)
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      commit(CatalogMutationType.SET_LOADING, false)
      throw e
    }
  },
  async [CatalogActionType.FETCH_ADD_TO_WISHLIST] ({ commit, state }, dto: IFetchAddToWishListRequest) {
    try {
      commit(CatalogMutationType.SET_LOADING, true)
      commit(CatalogMutationType.SET_FAVORITES_LOADING, true)
      const { data: wishList } = await apolloClient.mutate<IFetchAddToWishListResponse, IFetchAddToWishListRequest>({
        mutation: fetchProductsToWishlistMutation,
        refetchQueries: [{ query: fetchWishlistQuery }],
        variables: {
          wishlist_id: dto.wishlist_id,
          sku: dto.sku,
          currentPage: 1
        }
      })
      commit(CatalogMutationType.SET_WISHLIST, wishList?.addProductsToWishlist.wishlist as IWishList)
      const data = updateObjectInArray(state.products, dto.sku, 'sku', { favourites: 1 })
      commit(CatalogMutationType.SET_PRODUCTS, data)
      const skus: string[] = []
      const items = wishList?.addProductsToWishlist.wishlist.items_v2.items
      items?.map((item: ItemType) => skus.push(item.product.sku))

      const { data: favorites } = await apolloClient.query<IFetchProductsResponse, IFetchProductsRequest>({
        query: fetchProductsQuery,
        variables: {
          sku: skus,
          currentPage: 1
        }
      })
      commit(CatalogMutationType.SET_PRODUCT, { ...state.openedProduct, favourites: 1 } as IProduct)

      commit(CatalogMutationType.SET_FAVORITES, favorites.products.items)
      commit(CatalogMutationType.SET_FAVORITES_INFO, {
        ...(favorites?.products?.page_info || {}),
        total_count: favorites?.products?.total_count || 0
      })
      commit(CatalogMutationType.SET_FAVORITES_LOADING, false)
      commit(CatalogMutationType.SET_LOADING, false)
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      commit(CatalogMutationType.SET_FAVORITES_LOADING, false)
      throw e
    }
  },
  async [CatalogActionType.FETCH_REMOVE_FROM_WISHLIST] ({ commit, state }, dto: IFetchRemoveFromWishListRequest) {
    try {
      commit(CatalogMutationType.SET_LOADING, true)
      commit(CatalogMutationType.SET_FAVORITES_LOADING, true)
      const { data: wishListData } = await apolloClient.mutate<
        IFetchRemoveFromWishListResponse,
        Omit<IFetchRemoveFromWishListRequest, 'sku'>
      >({
        mutation: fetchProductFromWishlistMutation,
        refetchQueries: [{ query: fetchWishlistQuery }],
        variables: {
          wishlist_id: dto.wishlist_id,
          wishlist_item_id: dto.wishlist_item_id
        }
      })
      commit(CatalogMutationType.SET_WISHLIST, wishListData?.removeProductsFromWishlist.wishlist as IWishList)
      const data = updateObjectInArray(state.products, dto.sku, 'sku', { favourites: 0 })
      commit(CatalogMutationType.SET_PRODUCTS, data)

      commit(CatalogMutationType.SET_PRODUCT, { ...state.openedProduct, favourites: 0 } as IProduct)

      const skus: string[] = []
      const items = wishListData?.removeProductsFromWishlist.wishlist.items_v2.items
      items?.map((item: ItemType) => skus.push(item.product.sku))

      const { data: favorites } = await apolloClient.query<IFetchProductsResponse, IFetchProductsRequest>({
        query: fetchProductsQuery,
        variables: {
          sku: skus,
          currentPage: 1
        }
      })
      commit(CatalogMutationType.SET_FAVORITES, favorites.products.items)
      commit(CatalogMutationType.SET_FAVORITES_INFO, {
        ...(favorites?.products?.page_info || {}),
        total_count: favorites?.products?.total_count || 0
      })

      commit(CatalogMutationType.SET_FAVORITES_LOADING, false)
      commit(CatalogMutationType.SET_LOADING, false)
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      commit(CatalogMutationType.SET_FAVORITES_LOADING, false)
      commit(CatalogMutationType.SET_LOADING, false)
    }
    commit(CatalogMutationType.SET_LOADING, false)
  },
  async [CatalogActionType.FETCH_CATEGORIES] ({ commit }, dto: IFetchCategoriesRequest) {
    try {
      commit(CatalogMutationType.SET_LOADING, true)
      const { data } = await apolloClient.query<IFetchCategoriesResponse, IFetchCategoriesRequest>({
        query: fetchCategoriesQuery,
        variables: {
          url_key: dto.url_key
        }
      })
      commit(CatalogMutationType.SET_CATEGORIES, data.categoryList)
      commit(CatalogMutationType.SET_LOADING, false)
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      commit(CatalogMutationType.SET_LOADING, false)
      throw e
    }
  },
  async [CatalogActionType.FETCH_SHIP_TO] ({ commit }, dto: IFetchShipToRequest) {
    localStorage.setItem('shipToId', dto.ship_to_id)
    commit(CatalogMutationType.SET_LOADING, true)

    try {
      const data = await fetchShipTos({
        ship_to_id: dto.ship_to_id
      })
      if (data) {
        commit(CatalogMutationType.SET_SHIP_TO, data)
        commit(CatalogMutationType.SET_LOADING, false)
      }
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      commit(CatalogMutationType.SET_LOADING, false)
      throw e
    }
    commit(CatalogMutationType.SET_LOADING, false)
  },
  async [CatalogActionType.FETCH_SHIP_TO_METHOD] ({ commit }, dto: IFetchShipToRequest) {
    localStorage.setItem('shipToId', dto.ship_to_id)
    sessionStorage.removeItem('alcohol-license-open')
    if (localStorage.getItem('customertype') !== 'Ontrade') {
      utils.methods.checkAlcoholLicense()
    }

    commit(CatalogMutationType.SET_LOADING, true)

    try {
      const data = await fetchShipingMethod({
        ship_to_id: dto.ship_to_id
      })
      if (data) {
        commit(CatalogMutationType.SET_SHIP_TO_METHOD, data)
        commit(CatalogMutationType.SET_SHIP_TO_ID, dto.ship_to_id)
      }
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      throw e
    }
    commit(CatalogMutationType.SET_LOADING, false)
  },
  async [CatalogActionType.FETCH_PAYMENT_METHOD] ({ commit }, dto: IFetchShipToRequest) {
    try {
      const data = await fetchPaymentMethod({
        ship_to_id: dto.ship_to_id
      })
      if (data) {
        commit(CatalogMutationType.SET_PAYMENT_METHOD, data)
        localStorage.setItem('paymentMethod', data.defaultmethod?.[0].value)
        localStorage.setItem('paymentMethodName', data.defaultmethod?.[0].title)
      }
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      throw e
    }
  },
  async [CatalogActionType.FETCH_PRODUCT_WISHLIST] ({ commit }) {
    try {
      const { data: productWishlist } = await apolloClient.query<IFetchProductsResponse, object>({
        query: fetchProductWishlistQuery,
        variables: {},
        context: {
          headers: {
            myfavourites: 1
          }
        }
      })

      commit(CatalogMutationType.SET_PRODUCT_WISHLIST, productWishlist?.products?.items || [])
      if (productWishlist) {
        commit(CatalogMutationType.SET_PRODUCT_WISHLIST_INFO, {
          ...(productWishlist?.products?.page_info || {}),
          total_count: productWishlist?.products?.total_count || 0
        })
      }
      commit(CatalogMutationType.SET_LOADING, false)
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      throw e
    }
  },
  async [CatalogActionType.FETCH_ADD_TO_FULL_ORDER] ({ commit }, dto: IFullOrderRequest) {
    try {
      commit(CatalogMutationType.SET_LOADING, true)
      const { data } = await apolloClient.mutate<IFullOrderResponse, IFullOrderRequest>({
        mutation: fetchAddToFullOrderMutation,
        variables: {
          sku: dto?.sku,
          removeItems: dto?.removeItems
        }
      })
      if (data) {
        commit(CatalogMutationType.SET_ADD_TO_FULL_ORDER, data)
        commit(CatalogMutationType.SET_LOADING, false)
      }
    } catch (error) {
      commit(CatalogMutationType.SET_LOADING, false)
      console.error('add full order error', error)
    }
  },
  async [CatalogActionType.FETCH_FREEBEER_ID] ({ commit }, dto: IFetchFreeBeerIdInput) {
    try {
      const { data } = await apolloClient.query<IFetchFreeBeerIdResponse, object>({
        query: fetchFreeBeerIdsQuery,
        variables: { ...dto }
      })
      // commit(CatalogMutationType.SET_RECOMMENDED_ITEMS, recommendItems.recommendItems)
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      throw e
    }
  },
  async [CatalogActionType.FETCH_FREEBEER_PRODUCT] ({ commit, state }, dto: IFetchFreeBeerIdInput) {
    try {
      if (state.freeBeersRunning) return
      commit(CatalogMutationType.SET_FREEBEERS_RUNNING, true)
      commit(CatalogMutationType.SET_LOADING, true)
      const { data } = await apolloClient.query<IFetchFreeBeerProductResponse, object>({
        query: fetchFreeBeerProductQuery,
        variables: { ...dto }
      })
      commit(CatalogMutationType.SET_FREE_BEER_PRODUCT, data.getFreeBeerProducts)
      commit(CatalogMutationType.SET_FREEBEERS_RUNNING, false)
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      commit(CatalogMutationType.SET_FREEBEERS_RUNNING, false)
      commit(CatalogMutationType.SET_LOADING, false)
      throw e
    }
    commit(CatalogMutationType.SET_LOADING, false)
  },
  async [CatalogActionType.FETCH_ADD_FREE_BEER_PRODUCT] ({ commit }, dto: IAddFreeBeerCartRequest) {
    try {
      commit(CatalogMutationType.SET_LOADING, true)

      const { data } = await apolloClient.mutate<IAddFreeBeerCartResponse, IAddFreeBeerCartRequest>({
        mutation: fetchAddFreeBeerToCartMutation,
        variables: {
          id: dto?.id,
          qty: dto?.qty,
          product_id: dto?.product_id,
          operate_flag: dto?.operate_flag
        }
      })

      if (data) {
        commit(CatalogMutationType.SET_ADD_FREE_BEER_PRODUCT, data)
        commit(CatalogMutationType.SET_LOADING, false)
      }
    } catch (error) {
      commit(CatalogMutationType.SET_LOADING, false)
      console.error('add full order error', error)
    }
  },
  async [CatalogActionType.FETCH_FREEBEERS_INFO] ({ commit }) {
    try {
      commit(CatalogMutationType.SET_LOADING, true)
      const { data } = await apolloClient.query<IFetchFreeBeerInfoResponse, IFetchFreeBeerInfoRequest>({
        query: fetchFreeBeersInfo
      })

      if (data) {
        commit(CatalogMutationType.SET_FREEBEERS_INFO, data)
        commit(CatalogMutationType.SET_LOADING, false)
      }
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      commit(CatalogMutationType.SET_LOADING, false)
      throw e
    }
  },
  async [CatalogActionType.FETCH_ADD_COMPLET_LAYER] ({ commit }, dto: IAddFreeBeerCompleteLayerRequest) {
    try {
      commit(CatalogMutationType.SET_LOADING, true)

      const { data } = await apolloClient.mutate<IAddFreeBeerCompleteLayerResponse, IAddFreeBeerCompleteLayerRequest>({
        mutation: fetchAddCompleteLayerMutation,
        variables: {
          id: dto?.id,
          new_qty: dto?.new_qty,
          product_id: dto?.product_id,
          operate_flag: dto?.operate_flag
        }
      })

      if (data) {
        commit(CatalogMutationType.SET_LOADING, false)
      }
    } catch (error) {
      commit(CatalogMutationType.SET_LOADING, false)
      console.error('add full order error', error)
    }
  },
  async [CatalogActionType.FETCH_REMOVE_FREE_BEER_PRODUCT] ({ commit }, dto: IRemoveFreeBeerCartRequest) {
    try {
      commit(CatalogMutationType.SET_LOADING, true)

      const { data } = await apolloClient.mutate<IAddFreeBeerCartResponse, IRemoveFreeBeerCartRequest>({
        mutation: fetchRemoveFreeBeerToCartMutation,
        variables: {
          item_id: dto?.item_id,
          id: dto?.id,
          product_id: dto?.product_id,
          operate_flag: dto?.operate_flag
        }
      })

      if (data) {
        commit(CatalogMutationType.SET_ADD_FREE_BEER_PRODUCT, data)
        commit(CatalogMutationType.SET_LOADING, false)
      }
    } catch (error) {
      commit(CatalogMutationType.SET_LOADING, false)
      console.error('add full order error', error)
    }
  },
  async [CatalogActionType.FETCH_REMOVE_MULTIPLE_FREE_BEER_PRODUCT] ({ commit }, dto: IRemoveMultipleFreeBeerCartRequest) {
    try {
      commit(CatalogMutationType.SET_LOADING, true)
      const { data } = await apolloClient.mutate<IRemoveMultipleFreeBeerCartRequest>({
        mutation: fetchRemoveMultipleFreeBeer,
        variables: {
          input: dto.input
        }
      })

      if (data) {
        commit(CatalogMutationType.SET_LOADING, false)
      }
    } catch (error) {
      commit(CatalogMutationType.SET_LOADING, false)
    }
  },
  async [CatalogActionType.FETCH_SHIP_TO_ADDRESS] ({ commit }, dto: IFetchShipToIdRequest) {
    try {
      const data = await fetchShipToAddress({
        id: dto.id
      })
      if (data) {
        commit(CatalogMutationType.SET_SHIP_TO_ADDRESS, data)
      }
    } catch (e: unknown) {
      commit(CatalogMutationType.SET_ERROR, e as IError[])
      throw e
    }
  }
}

const fetchShipTos = async (dto: IFetchShipToRequest): Promise<IFetchShipToResponse> => {
  const response: AxiosResponse = await generalServiceV1API.get<IFetchShipToResponse>(
    `shiptos/GetShipToBySapId/${dto.ship_to_id}`
  )
  return response.data
}

const fetchShipToAddress = async (dto: IFetchShipToIdRequest): Promise<IFetchShipToIdResponse> => {
  const response: AxiosResponse = await generalServiceV1API.get<IFetchShipToResponse>(
    `shiptos/GetShipToById/${dto.id}`
  )
  return response.data
}

const fetchShipingMethod = async (dto: IFetchShipToRequest): Promise<IFetchShipToMethodResponse> => {
  const response: AxiosResponse = await generalServiceV1API.get<IFetchShipToMethodResponse>(
    `paymentmethod/GetShippingmethodByOutletId?ShipToId=${dto.ship_to_id}`
  )
  return response.data
}

const fetchPaymentMethod = async (dto: IFetchShipToRequest): Promise<IFetchPaymentMethodResponse> => {
  const response: AxiosResponse = await generalServiceV1API.get<IFetchPaymentMethodResponse>(
    `paymentmethod/GetPaymentMethodByOutletId?ShipToId=${dto.ship_to_id}`
  )
  return response.data
}

const CatalogModule = {
  namespaced: true,
  state,
  mutations,
  actions
}
export default CatalogModule
